import { createFileRoute } from '@tanstack/react-router'

type BrowseSearchParams = {
  q?: string
  location?: string
  jobType?: string
  experienceLevel?: string
  page?: number
  limit?: number
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
  salaryMin?: number
  salaryMax?: number
  postedWithinDays?: number
  source?: 'all' | 'internal' | 'external'
}

export const Route = createFileRoute('/$locale/browse')({
  validateSearch: (search: Record<string, unknown>): BrowseSearchParams => ({
    q: (search.q as string) || undefined,
    location: (search.location as string) || undefined,
    jobType: (search.jobType as string) || undefined,
    experienceLevel: (search.experienceLevel as string) || undefined,
    page: Number(search.page) || 1,
    limit: Number(search.limit) || 20,
    sortBy: (search.sortBy as string) || 'datePosted',
    sortOrder: (search.sortOrder as 'asc' | 'desc') || 'desc',
    salaryMin: search.salaryMin ? Number(search.salaryMin) : undefined,
    salaryMax: search.salaryMax ? Number(search.salaryMax) : undefined,
    postedWithinDays: search.postedWithinDays ? Number(search.postedWithinDays) : undefined,
    source: (['all', 'internal', 'external'].includes(search.source as string)
      ? (search.source as 'all' | 'internal' | 'external')
      : undefined),
  }),
})
